<h1 mat-dialog-title class="new-case-title">
  <span class="new-case-heading">New Case</span>
  <span class="new-case-timer" *ngIf="isAutoCloseActive">Closes in {{ secondsRemaining }}s</span>
</h1>

<div mat-dialog-content class="new-case-content">
  <p class="new-case-message">{{ isCreatingCase ? 'Creating case...' : 'The case has been created. Update the details below, or choose Ignore to keep it as-is.' }}</p>
  <div class="case-selection" *ngIf="data.isCourt">
    <div>
      <span class="case-selection-label">Selected case</span>
      <strong>{{ selectedCaseId ? (data.caseNumber || 'None') : 'None' }}</strong>
    </div>
    <div class="case-selection-actions">
      <button mat-stroked-button color="primary" type="button" (click)="selectCase()" [disabled]="isLoadingCase || isSubmitting">
        <mat-icon>list</mat-icon>
        {{ isLoadingCase ? 'Loading...' : 'Select Case' }}
      </button>
      <button mat-icon-button type="button" matTooltip="Remove selected case" (click)="clearCase()" [disabled]="!selectedCaseId || isSubmitting">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <section *ngIf="formFields.length" class="new-case-dynamic-fields">
    <h2>{{ data.selectedFormName || 'Form Details' }}</h2>
    <app-dynamic-form
      [fields]="formFields"
      [value]="data.formValues"
      (formReady)="onDynamicFormReady($event)">
    </app-dynamic-form>
  </section>
</div>

<div mat-dialog-actions class="new-case-actions" align="end">
  <button mat-button type="button" (click)="clearForm()" [disabled]="isSubmitting">Clear</button>
  <button mat-button type="button" (click)="ignore()" [disabled]="isSubmitting || isCreatingCase">Ignore</button>
  <button mat-raised-button color="primary" type="button" (click)="submit()" [disabled]="isSubmitting || isLoadingCase || isCreatingCase || !hasFormValues">
    <mat-spinner *ngIf="isSubmitting" diameter="18"></mat-spinner>
    <span *ngIf="!isSubmitting">Update Case</span>
  </button>
</div>